/* tslint:disable */
/* eslint-disable */
/**
 * LiningService API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMContractsCoordinateSystem2D = {
    Xy: 'XY',
    RTheta: 'RTheta',
    ThetaZ: 'ThetaZ',
} as const;

export type RHIMContractsCoordinateSystem2D = typeof RHIMContractsCoordinateSystem2D[keyof typeof RHIMContractsCoordinateSystem2D];



export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsFilterComparator = {
    Equal: 'Equal',
    NotEqual: 'NotEqual',
    Greater: 'Greater',
    Less: 'Less',
    GreaterOrEqual: 'GreaterOrEqual',
    LessOrEqual: 'LessOrEqual',
    Contains: 'Contains',
    DoesNotContain: 'DoesNotContain',
    StartWith: 'StartWith',
    EndsWith: 'EndsWith',
} as const;

export type RHIMContractsFilterComparator = typeof RHIMContractsFilterComparator[keyof typeof RHIMContractsFilterComparator];



export const RHIMContractsIndustry = {
    Steel: 'Steel',
    CementAndLime: 'CementAndLime',
    Nfm: 'NFM',
    Eec: 'EEC',
    Glass: 'Glass',
    Foundry: 'Foundry',
    Minerals: 'Minerals',
    ProcessIndustries: 'ProcessIndustries',
    Internal: 'Internal',
} as const;

export type RHIMContractsIndustry = typeof RHIMContractsIndustry[keyof typeof RHIMContractsIndustry];


export interface RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto {
    'data': Array<RHIMLiningServiceV1ModelsMaterialDto>;
    'cursor'?: string | null;
    'filter': Array<RHIMContractsPropertyFilter>;
    'orderBy': Array<RHIMContractsPropertyOrder>;
}
export interface RHIMContractsPropertyFilter {
    'property': string;
    'comparator': RHIMContractsFilterComparator;
    'value': string;
}


export interface RHIMContractsPropertyOrder {
    'property': string;
    'ascending': boolean;
}

export const RHIMContractsRegionLocation = {
    Bottom: 'Bottom',
    Barrel: 'Barrel',
    Cone: 'Cone',
    ThroatIn: 'ThroatIn',
    ThroatOut: 'ThroatOut',
    Side0: 'Side0',
    Side1: 'Side1',
    Side2: 'Side2',
    Side3: 'Side3',
} as const;

export type RHIMContractsRegionLocation = typeof RHIMContractsRegionLocation[keyof typeof RHIMContractsRegionLocation];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
    Cco: 'CCO',
    Ccy: 'CCY',
    Cca: 'CCA',
    Tun: 'TUN',
    Pcg: 'PCG',
    Hof: 'HOF',
    Anf: 'ANF',
    Maf: 'MAF',
    Tif: 'TIF',
    Shf: 'SHF',
    Tlc: 'TLC',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];



export const RHIMLiningServiceDataMaterialCharacteristics = {
    Brick: 'Brick',
    Mix: 'Mix',
} as const;

export type RHIMLiningServiceDataMaterialCharacteristics = typeof RHIMLiningServiceDataMaterialCharacteristics[keyof typeof RHIMLiningServiceDataMaterialCharacteristics];


export interface RHIMLiningServiceDataMaterialSearchRequest {
    'term'?: string | null;
    'source'?: RHIMLiningServiceDataMaterialSource | null;
    'industry'?: string | null;
    'materialCharacteristics'?: RHIMLiningServiceDataMaterialCharacteristics | null;
    'supplierId'?: string | null;
    'materialMainProductGroupId'?: string | null;
    'pageSize': number;
    'cursor'?: string | null;
    'filter': Array<RHIMContractsPropertyFilter>;
    'orderBy': Array<RHIMContractsPropertyOrder>;
}



export const RHIMLiningServiceDataMaterialSource = {
    Clip: 'CLIP',
    Manual: 'Manual',
    ETech: 'ETech',
    Sap: 'SAP',
} as const;

export type RHIMLiningServiceDataMaterialSource = typeof RHIMLiningServiceDataMaterialSource[keyof typeof RHIMLiningServiceDataMaterialSource];


export interface RHIMLiningServiceV1ModelsAggregatedLiningOverviewDto {
    'liningOverview'?: RHIMLiningServiceV1ModelsLiningOverviewDto | null;
    'aggregatedLiningRegions'?: Array<RHIMLiningServiceV1ModelsAggregatedLiningRegionDto> | null;
}
export interface RHIMLiningServiceV1ModelsAggregatedLiningRegionDto {
    /**
     * The ID for this lining region
     */
    'id': string;
    /**
     * DisplayName of the lining region  CANNOT be used to identify the lining region
     */
    'displayName'?: string | null;
    /**
     * Optional notes for this lining region
     */
    'notes'?: string | null;
    /**
     * The Supplier of the bricks. This will soon be another table instead of a free text value
     */
    'brickSupplier'?: string | null;
    /**
     * The Name of the type of brick. This will soon be another table instead of a free text value
     */
    'brickName'?: string | null;
    /**
     * Initial lining thickness in `mm`
     */
    'initialLiningThickness': number;
    /**
     * Critical lining thickness in `mm`
     */
    'criticalLiningThickness': number;
    /**
     * Part of the vessel in which this lining region is located
     */
    'regionLocation': RHIMContractsRegionLocation;
    /**
     * Coordinate system used by the points in this lining region
     */
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    /**
     * The first point which defines this lining region.  Has normally lower values than the maximum point.  Except if the region wraps around the 360° boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'minimumPoint'?: RHIMLiningServiceV1ModelsLiningRegionPointDto | null;
    /**
     * The second point which defines this lining region.  Has normally higher values than the maximum point.  Except if the region wraps around the 360° boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'maximumPoint'?: RHIMLiningServiceV1ModelsLiningRegionPointDto | null;
    /**
     * The date when this lining region was put into the vessel
     */
    'installationDate': string;
    /**
     * The color representation of the brick type to display in the frontend.  Represented as a hex color code, e.g. ```#fc30c2```
     */
    'displayColor'?: string | null;
}


export interface RHIMLiningServiceV1ModelsBrickInformationDto {
    /**
     * The Supplier of the bricks. This will soon be another table instead of a free text value
     */
    'brickSupplier'?: string | null;
    /**
     * The Name of the type of brick. This will soon be another table instead of a free text value
     */
    'brickName'?: string | null;
}
export interface RHIMLiningServiceV1ModelsCreateLiningDto {
    /**
     * Optional list of lining regions that should be created immediately with the lining
     */
    'liningRegions'?: Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto> | null;
    /**
     * DisplayName of the lining  CANNOT be used to identify the lining
     */
    'displayName': string;
    /**
     * The date when this lining was put into the vessel
     */
    'installationDate': string;
}
export interface RHIMLiningServiceV1ModelsCreateMaterialDto {
    'name': string;
    'supplierId': string;
    'materialMainProductGroupId'?: string | null;
    'density'?: number | null;
    'source': RHIMLiningServiceDataMaterialSource;
    'industries'?: Array<string> | null;
    'materialCharacteristics': RHIMLiningServiceDataMaterialCharacteristics;
    'sap'?: string | null;
}


export interface RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto {
    /**
     * For updated regions this holds the id of the lining region  For newly created regions this id should be left empty
     */
    'id'?: string | null;
    /**
     * DisplayName of the lining region  CANNOT be used to identify the lining region
     */
    'displayName': string;
    /**
     * Optional notes for this lining region
     */
    'notes'?: string | null;
    /**
     * Legacy free-text supplier. New and updated lining regions use MaterialId.
     */
    'brickSupplier'?: string | null;
    /**
     * Legacy free-text material name. New and updated lining regions use MaterialId.
     */
    'brickName'?: string | null;
    /**
     * Material used by this lining region.
     */
    'materialId': string;
    /**
     * Initial lining thickness in `mm`
     */
    'initialLiningThickness': number;
    /**
     * Critical lining thickness in `mm`
     */
    'criticalLiningThickness': number;
    /**
     * Part of the vessel in which this lining region is located
     */
    'regionLocation': RHIMContractsRegionLocation;
    /**
     * Coordinate system used by the points in this lining region
     */
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    /**
     * The first point which defines this lining region.  Has normally lower values than the maximum point.  Except if the region wraps around the 360 degree boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'minimumPoint': RHIMLiningServiceV1ModelsLiningRegionPointDto;
    /**
     * The second point which defines this lining region.  Has normally higher values than the maximum point.  Except if the region wraps around the 360 degree boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'maximumPoint': RHIMLiningServiceV1ModelsLiningRegionPointDto;
}


export interface RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto {
    'name': string;
}
export interface RHIMLiningServiceV1ModelsLiningDto {
    /**
     * The ordered list of the lining regions of this lining. Earlier linings in the list cover/overwrite linings that come later.
     */
    'liningRegions'?: Array<RHIMLiningServiceV1ModelsLiningRegionDto> | null;
    'id': string;
    /**
     * References the vessel to which this lining belongs
     */
    'vesselId': string;
    /**
     * DisplayName of the lining  CANNOT be used to identify the lining
     */
    'displayName'?: string | null;
    /**
     * The date when this lining was put into the vessel
     */
    'installationDate': string;
    /**
     * List of all the brick suppliers used in this lining
     */
    'brickSuppliers'?: Array<string> | null;
}
export interface RHIMLiningServiceV1ModelsLiningOverviewDto {
    'id': string;
    /**
     * References the vessel to which this lining belongs
     */
    'vesselId': string;
    /**
     * DisplayName of the lining  CANNOT be used to identify the lining
     */
    'displayName'?: string | null;
    /**
     * The date when this lining was put into the vessel
     */
    'installationDate': string;
    /**
     * List of all the brick suppliers used in this lining
     */
    'brickSuppliers'?: Array<string> | null;
}
export interface RHIMLiningServiceV1ModelsLiningRegionDto {
    'id': string;
    /**
     * DisplayName of the lining region  CANNOT be used to identify the lining region
     */
    'displayName'?: string | null;
    /**
     * Optional notes for this lining region
     */
    'notes'?: string | null;
    /**
     * The Supplier of the bricks. This will soon be another table instead of a free text value
     */
    'brickSupplier'?: string | null;
    /**
     * The Name of the type of brick. This will soon be another table instead of a free text value
     */
    'brickName'?: string | null;
    /**
     * Material used by this lining region.
     */
    'materialId'?: string | null;
    /**
     * Initial lining thickness in `mm`
     */
    'initialLiningThickness': number;
    /**
     * Critical lining thickness in `mm`
     */
    'criticalLiningThickness': number;
    /**
     * Part of the vessel in which this lining region is located
     */
    'regionLocation': RHIMContractsRegionLocation;
    /**
     * Coordinate system used by the points in this lining region
     */
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    /**
     * The first point which defines this lining region.  Has normally lower values than the maximum point.  Except if the region wraps around the 360° boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'minimumPoint'?: RHIMLiningServiceV1ModelsLiningRegionPointDto | null;
    /**
     * The second point which defines this lining region.  Has normally higher values than the maximum point.  Except if the region wraps around the 360° boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'maximumPoint'?: RHIMLiningServiceV1ModelsLiningRegionPointDto | null;
}


export interface RHIMLiningServiceV1ModelsLiningRegionPointDto {
    'r'?: number | null;
    'theta'?: number | null;
    'z'?: number | null;
    'x'?: number | null;
    'y'?: number | null;
}
export interface RHIMLiningServiceV1ModelsLiningThicknessDto {
    'initialLiningThickness': number;
    /**
     * Critical lining thickness in `mm`
     */
    'criticalLiningThickness': number;
    'brickInformation': RHIMLiningServiceV1ModelsBrickInformationDto;
}
export interface RHIMLiningServiceV1ModelsMaterialDto {
    'id': string;
    'name'?: string | null;
    'supplierId': string;
    'supplierName'?: string | null;
    'materialMainProductGroupId'?: string | null;
    'materialMainProductGroupShortName'?: string | null;
    'materialMainProductGroupFullName'?: string | null;
    'density'?: number | null;
    'source': RHIMLiningServiceDataMaterialSource;
    'industries'?: Array<string> | null;
    'materialCharacteristics': RHIMLiningServiceDataMaterialCharacteristics;
    'sap'?: string | null;
    'isEditable': boolean;
}


export interface RHIMLiningServiceV1ModelsMaterialMainProductGroupDto {
    'id': string;
    'shortName'?: string | null;
    'fullName'?: string | null;
}
export interface RHIMLiningServiceV1ModelsRegionLiningThicknessDto {
    /**
     * Contains the one lining thickness from the list of possible lining thicknesses with the lowest InitialLiningThickness.
     */
    'minimumLiningThickness'?: RHIMLiningServiceV1ModelsLiningThicknessDto | null;
    /**
     * Contains a list of all the lining thicknesses which appear inside the requested region (including the one under MinimumLiningThickness)
     */
    'brickInformation'?: Array<RHIMLiningServiceV1ModelsBrickInformationDto> | null;
}
export interface RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto {
    /**
     * The first point which defines this region.  Has normally lower values than the maximum point.  Except if the region wraps around the 360° boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'minimumPoint': RHIMLiningServiceV1ModelsLiningRegionPointDto;
    /**
     * The second point which defines this region.  Has normally higher values than the maximum point.  Except if the region wraps around the 360° boundary.  Then the minimum point has a higher angle value than the maximum point.
     */
    'maximumPoint': RHIMLiningServiceV1ModelsLiningRegionPointDto;
    /**
     * Decides in which region location the lining is searched.
     */
    'requestedLocation'?: RHIMContractsRegionLocation | null;
    /**
     * Decides which linings to consider. Only lining older than this date are considered.  If the value is not provided all the linings are considered.
     */
    'requestedDate'?: string | null;
}


export interface RHIMLiningServiceV1ModelsSupplierDto {
    'id': string;
    'name'?: string | null;
}
export interface RHIMLiningServiceV1ModelsUpdateLiningDto {
    /**
     * DisplayName of the lining  CANNOT be used to identify the lining
     */
    'displayName': string;
    /**
     * The date when this lining was put into the vessel
     */
    'installationDate': string;
}
export interface RHIMLiningServiceV1ModelsUpdateMaterialDto {
    'name': string;
    'supplierId': string;
    'materialMainProductGroupId'?: string | null;
    'density'?: number | null;
    'source': RHIMLiningServiceDataMaterialSource;
    'industries'?: Array<string> | null;
    'materialCharacteristics': RHIMLiningServiceDataMaterialCharacteristics;
    'sap'?: string | null;
}



/**
 * LiningRegionsApi - axios parameter creator
 */
export const LiningRegionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /liningRegions/{liningRegionId} - DELETE
         * @param {string} liningRegionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiningregionsLiningregionid: async (liningRegionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningRegionId' is not null or undefined
            assertParamExists('deleteLiningregionsLiningregionid', 'liningRegionId', liningRegionId)
            const localVarPath = `/liningRegions/{liningRegionId}`
                .replace('{liningRegionId}', encodeURIComponent(String(liningRegionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /linings/{liningId} - POST
         * @param {string} liningId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiningsLiningid: async (liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningId' is not null or undefined
            assertParamExists('postLiningsLiningid', 'liningId', liningId)
            const localVarPath = `/linings/{liningId}`
                .replace('{liningId}', encodeURIComponent(String(liningId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /linings/{liningId}/liningRegionsOrder - POST
         * @param {string} liningId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiningsLiningidLiningregionsorder: async (liningId: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningId' is not null or undefined
            assertParamExists('postLiningsLiningidLiningregionsorder', 'liningId', liningId)
            const localVarPath = `/linings/{liningId}/liningRegionsOrder`
                .replace('{liningId}', encodeURIComponent(String(liningId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /liningRegions/{liningRegionId} - PUT
         * @param {string} liningRegionId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLiningregionsLiningregionid: async (liningRegionId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningRegionId' is not null or undefined
            assertParamExists('putLiningregionsLiningregionid', 'liningRegionId', liningRegionId)
            const localVarPath = `/liningRegions/{liningRegionId}`
                .replace('{liningRegionId}', encodeURIComponent(String(liningRegionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /linings/{liningId}/liningRegions - PUT
         * @param {string} liningId 
         * @param {Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLiningsLiningidLiningregions: async (liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningId' is not null or undefined
            assertParamExists('putLiningsLiningidLiningregions', 'liningId', liningId)
            const localVarPath = `/linings/{liningId}/liningRegions`
                .replace('{liningId}', encodeURIComponent(String(liningId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiningRegionsApi - functional programming interface
 */
export const LiningRegionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiningRegionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /liningRegions/{liningRegionId} - DELETE
         * @param {string} liningRegionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLiningregionsLiningregionid(liningRegionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLiningregionsLiningregionid(liningRegionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningRegionsApi.deleteLiningregionsLiningregionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /linings/{liningId} - POST
         * @param {string} liningId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLiningsLiningid(liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsLiningRegionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLiningsLiningid(liningId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningRegionsApi.postLiningsLiningid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /linings/{liningId}/liningRegionsOrder - POST
         * @param {string} liningId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLiningsLiningidLiningregionsorder(liningId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLiningsLiningidLiningregionsorder(liningId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningRegionsApi.postLiningsLiningidLiningregionsorder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /liningRegions/{liningRegionId} - PUT
         * @param {string} liningRegionId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putLiningregionsLiningregionid(liningRegionId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsLiningRegionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putLiningregionsLiningregionid(liningRegionId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningRegionsApi.putLiningregionsLiningregionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /linings/{liningId}/liningRegions - PUT
         * @param {string} liningId 
         * @param {Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putLiningsLiningidLiningregions(liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putLiningsLiningidLiningregions(liningId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningRegionsApi.putLiningsLiningidLiningregions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LiningRegionsApi - factory interface
 */
export const LiningRegionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiningRegionsApiFp(configuration)
    return {
        /**
         * 
         * @summary /liningRegions/{liningRegionId} - DELETE
         * @param {string} liningRegionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiningregionsLiningregionid(liningRegionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLiningregionsLiningregionid(liningRegionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /linings/{liningId} - POST
         * @param {string} liningId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiningsLiningid(liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsLiningRegionDto> {
            return localVarFp.postLiningsLiningid(liningId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /linings/{liningId}/liningRegionsOrder - POST
         * @param {string} liningId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiningsLiningidLiningregionsorder(liningId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postLiningsLiningidLiningregionsorder(liningId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /liningRegions/{liningRegionId} - PUT
         * @param {string} liningRegionId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLiningregionsLiningregionid(liningRegionId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsLiningRegionDto> {
            return localVarFp.putLiningregionsLiningregionid(liningRegionId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /linings/{liningId}/liningRegions - PUT
         * @param {string} liningId 
         * @param {Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLiningsLiningidLiningregions(liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putLiningsLiningidLiningregions(liningId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LiningRegionsApi - object-oriented interface
 */
export class LiningRegionsApi extends BaseAPI {
    /**
     * 
     * @summary /liningRegions/{liningRegionId} - DELETE
     * @param {string} liningRegionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLiningregionsLiningregionid(liningRegionId: string, options?: RawAxiosRequestConfig) {
        return LiningRegionsApiFp(this.configuration).deleteLiningregionsLiningregionid(liningRegionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /linings/{liningId} - POST
     * @param {string} liningId 
     * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postLiningsLiningid(liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options?: RawAxiosRequestConfig) {
        return LiningRegionsApiFp(this.configuration).postLiningsLiningid(liningId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /linings/{liningId}/liningRegionsOrder - POST
     * @param {string} liningId 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postLiningsLiningidLiningregionsorder(liningId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return LiningRegionsApiFp(this.configuration).postLiningsLiningidLiningregionsorder(liningId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /liningRegions/{liningRegionId} - PUT
     * @param {string} liningRegionId 
     * @param {RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putLiningregionsLiningregionid(liningRegionId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options?: RawAxiosRequestConfig) {
        return LiningRegionsApiFp(this.configuration).putLiningregionsLiningregionid(liningRegionId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /linings/{liningId}/liningRegions - PUT
     * @param {string} liningId 
     * @param {Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>} [rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putLiningsLiningidLiningregions(liningId: string, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto?: Array<RHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto>, options?: RawAxiosRequestConfig) {
        return LiningRegionsApiFp(this.configuration).putLiningsLiningidLiningregions(liningId, rHIMLiningServiceV1ModelsCreateOrUpdateLiningRegionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LiningsApi - axios parameter creator
 */
export const LiningsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a lining
         * @summary Delete a lining
         * @param {string} liningId Identifier of the lining
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiningsLiningid: async (liningId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningId' is not null or undefined
            assertParamExists('deleteLiningsLiningid', 'liningId', liningId)
            const localVarPath = `/linings/{liningId}`
                .replace('{liningId}', encodeURIComponent(String(liningId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a lining by id
         * @summary Retrieves a lining by id
         * @param {string} liningId Identifier of the lining
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiningsLiningid: async (liningId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningId' is not null or undefined
            assertParamExists('getLiningsLiningid', 'liningId', liningId)
            const localVarPath = `/linings/{liningId}`
                .replace('{liningId}', encodeURIComponent(String(liningId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
         * @summary Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
         * @param {string} vesselId Identifier of the vessel
         * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAggregate: async (vesselId: string, requestedDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidAggregate', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/aggregate`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (requestedDate !== undefined) {
                localVarQueryParameter['requestedDate'] = requestedDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all aggregated linings for a given vessel id
         * @summary Retrieves all aggregated linings for a given vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are used
         * @param {boolean} [carryOver] If true linings from older linings will be carried over to the newer ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAggregatedlinings: async (vesselId: string, requestedDate?: string, carryOver?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidAggregatedlinings', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/aggregatedLinings`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (requestedDate !== undefined) {
                localVarQueryParameter['requestedDate'] = requestedDate;
            }

            if (carryOver !== undefined) {
                localVarQueryParameter['carryOver'] = carryOver;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all linings for a given vessel id
         * @summary Retrieves all linings for a given vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidLinings: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidLinings', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/linings`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new lining
         * @summary Create a new lining
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMLiningServiceV1ModelsCreateLiningDto} [rHIMLiningServiceV1ModelsCreateLiningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselsVesselidLinings: async (vesselId: string, rHIMLiningServiceV1ModelsCreateLiningDto?: RHIMLiningServiceV1ModelsCreateLiningDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postVesselsVesselidLinings', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/linings`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateLiningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
         * @summary Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto} [rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto] The region lining thickness request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselsVesselidRegionthickness: async (vesselId: string, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto?: RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postVesselsVesselidRegionthickness', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/regionthickness`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a lining
         * @summary Update a lining
         * @param {string} liningId Identifier of the lining
         * @param {RHIMLiningServiceV1ModelsUpdateLiningDto} [rHIMLiningServiceV1ModelsUpdateLiningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLiningsLiningid: async (liningId: string, rHIMLiningServiceV1ModelsUpdateLiningDto?: RHIMLiningServiceV1ModelsUpdateLiningDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningId' is not null or undefined
            assertParamExists('putLiningsLiningid', 'liningId', liningId)
            const localVarPath = `/linings/{liningId}`
                .replace('{liningId}', encodeURIComponent(String(liningId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsUpdateLiningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiningsApi - functional programming interface
 */
export const LiningsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiningsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a lining
         * @summary Delete a lining
         * @param {string} liningId Identifier of the lining
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLiningsLiningid(liningId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLiningsLiningid(liningId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.deleteLiningsLiningid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a lining by id
         * @summary Retrieves a lining by id
         * @param {string} liningId Identifier of the lining
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiningsLiningid(liningId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsLiningDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiningsLiningid(liningId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.getLiningsLiningid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
         * @summary Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
         * @param {string} vesselId Identifier of the vessel
         * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidAggregate(vesselId: string, requestedDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMLiningServiceV1ModelsAggregatedLiningRegionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidAggregate(vesselId, requestedDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.getVesselsVesselidAggregate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all aggregated linings for a given vessel id
         * @summary Retrieves all aggregated linings for a given vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are used
         * @param {boolean} [carryOver] If true linings from older linings will be carried over to the newer ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidAggregatedlinings(vesselId: string, requestedDate?: string, carryOver?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMLiningServiceV1ModelsAggregatedLiningOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidAggregatedlinings(vesselId, requestedDate, carryOver, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.getVesselsVesselidAggregatedlinings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all linings for a given vessel id
         * @summary Retrieves all linings for a given vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidLinings(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMLiningServiceV1ModelsLiningOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidLinings(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.getVesselsVesselidLinings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new lining
         * @summary Create a new lining
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMLiningServiceV1ModelsCreateLiningDto} [rHIMLiningServiceV1ModelsCreateLiningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVesselsVesselidLinings(vesselId: string, rHIMLiningServiceV1ModelsCreateLiningDto?: RHIMLiningServiceV1ModelsCreateLiningDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsLiningOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVesselsVesselidLinings(vesselId, rHIMLiningServiceV1ModelsCreateLiningDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.postVesselsVesselidLinings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
         * @summary Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto} [rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto] The region lining thickness request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVesselsVesselidRegionthickness(vesselId: string, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto?: RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsRegionLiningThicknessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVesselsVesselidRegionthickness(vesselId, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.postVesselsVesselidRegionthickness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a lining
         * @summary Update a lining
         * @param {string} liningId Identifier of the lining
         * @param {RHIMLiningServiceV1ModelsUpdateLiningDto} [rHIMLiningServiceV1ModelsUpdateLiningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putLiningsLiningid(liningId: string, rHIMLiningServiceV1ModelsUpdateLiningDto?: RHIMLiningServiceV1ModelsUpdateLiningDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsLiningDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putLiningsLiningid(liningId, rHIMLiningServiceV1ModelsUpdateLiningDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiningsApi.putLiningsLiningid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LiningsApi - factory interface
 */
export const LiningsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiningsApiFp(configuration)
    return {
        /**
         * Delete a lining
         * @summary Delete a lining
         * @param {string} liningId Identifier of the lining
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLiningsLiningid(liningId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLiningsLiningid(liningId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a lining by id
         * @summary Retrieves a lining by id
         * @param {string} liningId Identifier of the lining
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiningsLiningid(liningId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsLiningDto> {
            return localVarFp.getLiningsLiningid(liningId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
         * @summary Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
         * @param {string} vesselId Identifier of the vessel
         * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAggregate(vesselId: string, requestedDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMLiningServiceV1ModelsAggregatedLiningRegionDto>> {
            return localVarFp.getVesselsVesselidAggregate(vesselId, requestedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all aggregated linings for a given vessel id
         * @summary Retrieves all aggregated linings for a given vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are used
         * @param {boolean} [carryOver] If true linings from older linings will be carried over to the newer ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAggregatedlinings(vesselId: string, requestedDate?: string, carryOver?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMLiningServiceV1ModelsAggregatedLiningOverviewDto>> {
            return localVarFp.getVesselsVesselidAggregatedlinings(vesselId, requestedDate, carryOver, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all linings for a given vessel id
         * @summary Retrieves all linings for a given vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidLinings(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMLiningServiceV1ModelsLiningOverviewDto>> {
            return localVarFp.getVesselsVesselidLinings(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new lining
         * @summary Create a new lining
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMLiningServiceV1ModelsCreateLiningDto} [rHIMLiningServiceV1ModelsCreateLiningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselsVesselidLinings(vesselId: string, rHIMLiningServiceV1ModelsCreateLiningDto?: RHIMLiningServiceV1ModelsCreateLiningDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsLiningOverviewDto> {
            return localVarFp.postVesselsVesselidLinings(vesselId, rHIMLiningServiceV1ModelsCreateLiningDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
         * @summary Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto} [rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto] The region lining thickness request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselsVesselidRegionthickness(vesselId: string, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto?: RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsRegionLiningThicknessDto> {
            return localVarFp.postVesselsVesselidRegionthickness(vesselId, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a lining
         * @summary Update a lining
         * @param {string} liningId Identifier of the lining
         * @param {RHIMLiningServiceV1ModelsUpdateLiningDto} [rHIMLiningServiceV1ModelsUpdateLiningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLiningsLiningid(liningId: string, rHIMLiningServiceV1ModelsUpdateLiningDto?: RHIMLiningServiceV1ModelsUpdateLiningDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsLiningDto> {
            return localVarFp.putLiningsLiningid(liningId, rHIMLiningServiceV1ModelsUpdateLiningDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LiningsApi - object-oriented interface
 */
export class LiningsApi extends BaseAPI {
    /**
     * Delete a lining
     * @summary Delete a lining
     * @param {string} liningId Identifier of the lining
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLiningsLiningid(liningId: string, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).deleteLiningsLiningid(liningId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a lining by id
     * @summary Retrieves a lining by id
     * @param {string} liningId Identifier of the lining
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLiningsLiningid(liningId: string, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).getLiningsLiningid(liningId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
     * @summary Retrieves the aggregated lining for a vessel at a given point in time. This currently only works for CRK vessels.  The API also returns a color mapping for each brick type. This color mapping is kept consistent per campaign.
     * @param {string} vesselId Identifier of the vessel
     * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidAggregate(vesselId: string, requestedDate?: string, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).getVesselsVesselidAggregate(vesselId, requestedDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all aggregated linings for a given vessel id
     * @summary Retrieves all aggregated linings for a given vessel id
     * @param {string} vesselId Identifier of the vessel
     * @param {string} [requestedDate] The date for which the current state of the lining should be returned. If no date is given all linings are used
     * @param {boolean} [carryOver] If true linings from older linings will be carried over to the newer ones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidAggregatedlinings(vesselId: string, requestedDate?: string, carryOver?: boolean, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).getVesselsVesselidAggregatedlinings(vesselId, requestedDate, carryOver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all linings for a given vessel id
     * @summary Retrieves all linings for a given vessel id
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidLinings(vesselId: string, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).getVesselsVesselidLinings(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new lining
     * @summary Create a new lining
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMLiningServiceV1ModelsCreateLiningDto} [rHIMLiningServiceV1ModelsCreateLiningDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVesselsVesselidLinings(vesselId: string, rHIMLiningServiceV1ModelsCreateLiningDto?: RHIMLiningServiceV1ModelsCreateLiningDto, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).postVesselsVesselidLinings(vesselId, rHIMLiningServiceV1ModelsCreateLiningDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
     * @summary Retrieves all lining thicknesses for a given vessel id, region and a campaign start date.  If none are found a 204 status code is returned.
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto} [rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto] The region lining thickness request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVesselsVesselidRegionthickness(vesselId: string, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto?: RHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).postVesselsVesselidRegionthickness(vesselId, rHIMLiningServiceV1ModelsRegionLiningThicknessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a lining
     * @summary Update a lining
     * @param {string} liningId Identifier of the lining
     * @param {RHIMLiningServiceV1ModelsUpdateLiningDto} [rHIMLiningServiceV1ModelsUpdateLiningDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putLiningsLiningid(liningId: string, rHIMLiningServiceV1ModelsUpdateLiningDto?: RHIMLiningServiceV1ModelsUpdateLiningDto, options?: RawAxiosRequestConfig) {
        return LiningsApiFp(this.configuration).putLiningsLiningid(liningId, rHIMLiningServiceV1ModelsUpdateLiningDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MaterialMainProductGroupsApi - axios parameter creator
 */
export const MaterialMainProductGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /materialMainProductGroups - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialmainproductgroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/materialMainProductGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaterialMainProductGroupsApi - functional programming interface
 */
export const MaterialMainProductGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaterialMainProductGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /materialMainProductGroups - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialmainproductgroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMLiningServiceV1ModelsMaterialMainProductGroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialmainproductgroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialMainProductGroupsApi.getMaterialmainproductgroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaterialMainProductGroupsApi - factory interface
 */
export const MaterialMainProductGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaterialMainProductGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary /materialMainProductGroups - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialmainproductgroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMLiningServiceV1ModelsMaterialMainProductGroupDto>> {
            return localVarFp.getMaterialmainproductgroups(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaterialMainProductGroupsApi - object-oriented interface
 */
export class MaterialMainProductGroupsApi extends BaseAPI {
    /**
     * 
     * @summary /materialMainProductGroups - GET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMaterialmainproductgroups(options?: RawAxiosRequestConfig) {
        return MaterialMainProductGroupsApiFp(this.configuration).getMaterialmainproductgroups(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MaterialsApi - axios parameter creator
 */
export const MaterialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /materials/{materialId} - DELETE
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaterialsMaterialid: async (materialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialId' is not null or undefined
            assertParamExists('deleteMaterialsMaterialid', 'materialId', materialId)
            const localVarPath = `/materials/{materialId}`
                .replace('{materialId}', encodeURIComponent(String(materialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /materials - GET
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterials: async (cursor?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /materials/{materialId} - GET
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialsMaterialid: async (materialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialId' is not null or undefined
            assertParamExists('getMaterialsMaterialid', 'materialId', materialId)
            const localVarPath = `/materials/{materialId}`
                .replace('{materialId}', encodeURIComponent(String(materialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /materials/search?Filter={Filter}&OrderBy={OrderBy} - GET
         * @param {Array<RHIMContractsPropertyFilter>} filter 
         * @param {Array<RHIMContractsPropertyOrder>} orderBy 
         * @param {string} [term] 
         * @param {string} [source] 
         * @param {string} [industry] 
         * @param {string} [materialCharacteristics] 
         * @param {string} [supplierId] 
         * @param {string} [materialMainProductGroupId] 
         * @param {number} [pageSize] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialsSearchFilterFilterOrderbyOrderby: async (filter: Array<RHIMContractsPropertyFilter>, orderBy: Array<RHIMContractsPropertyOrder>, term?: string, source?: string, industry?: string, materialCharacteristics?: string, supplierId?: string, materialMainProductGroupId?: string, pageSize?: number, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('getMaterialsSearchFilterFilterOrderbyOrderby', 'filter', filter)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getMaterialsSearchFilterFilterOrderbyOrderby', 'orderBy', orderBy)
            const localVarPath = `/materials/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (orderBy) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (source !== undefined) {
                localVarQueryParameter['Source'] = source;
            }

            if (industry !== undefined) {
                localVarQueryParameter['Industry'] = industry;
            }

            if (materialCharacteristics !== undefined) {
                localVarQueryParameter['MaterialCharacteristics'] = materialCharacteristics;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['SupplierId'] = supplierId;
            }

            if (materialMainProductGroupId !== undefined) {
                localVarQueryParameter['MaterialMainProductGroupId'] = materialMainProductGroupId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['Cursor'] = cursor;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /materials - POST
         * @param {RHIMLiningServiceV1ModelsCreateMaterialDto} [rHIMLiningServiceV1ModelsCreateMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMaterials: async (rHIMLiningServiceV1ModelsCreateMaterialDto?: RHIMLiningServiceV1ModelsCreateMaterialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateMaterialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /materials/search - POST
         * @param {RHIMLiningServiceDataMaterialSearchRequest} [rHIMLiningServiceDataMaterialSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMaterialsSearch: async (rHIMLiningServiceDataMaterialSearchRequest?: RHIMLiningServiceDataMaterialSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/materials/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceDataMaterialSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /materials/{materialId} - PUT
         * @param {string} materialId 
         * @param {RHIMLiningServiceV1ModelsUpdateMaterialDto} [rHIMLiningServiceV1ModelsUpdateMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMaterialsMaterialid: async (materialId: string, rHIMLiningServiceV1ModelsUpdateMaterialDto?: RHIMLiningServiceV1ModelsUpdateMaterialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialId' is not null or undefined
            assertParamExists('putMaterialsMaterialid', 'materialId', materialId)
            const localVarPath = `/materials/{materialId}`
                .replace('{materialId}', encodeURIComponent(String(materialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsUpdateMaterialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaterialsApi - functional programming interface
 */
export const MaterialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaterialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /materials/{materialId} - DELETE
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMaterialsMaterialid(materialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMaterialsMaterialid(materialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.deleteMaterialsMaterialid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /materials - GET
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterials(cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterials(cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.getMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /materials/{materialId} - GET
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialsMaterialid(materialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialsMaterialid(materialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.getMaterialsMaterialid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /materials/search?Filter={Filter}&OrderBy={OrderBy} - GET
         * @param {Array<RHIMContractsPropertyFilter>} filter 
         * @param {Array<RHIMContractsPropertyOrder>} orderBy 
         * @param {string} [term] 
         * @param {string} [source] 
         * @param {string} [industry] 
         * @param {string} [materialCharacteristics] 
         * @param {string} [supplierId] 
         * @param {string} [materialMainProductGroupId] 
         * @param {number} [pageSize] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialsSearchFilterFilterOrderbyOrderby(filter: Array<RHIMContractsPropertyFilter>, orderBy: Array<RHIMContractsPropertyOrder>, term?: string, source?: string, industry?: string, materialCharacteristics?: string, supplierId?: string, materialMainProductGroupId?: string, pageSize?: number, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialsSearchFilterFilterOrderbyOrderby(filter, orderBy, term, source, industry, materialCharacteristics, supplierId, materialMainProductGroupId, pageSize, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.getMaterialsSearchFilterFilterOrderbyOrderby']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /materials - POST
         * @param {RHIMLiningServiceV1ModelsCreateMaterialDto} [rHIMLiningServiceV1ModelsCreateMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMaterials(rHIMLiningServiceV1ModelsCreateMaterialDto?: RHIMLiningServiceV1ModelsCreateMaterialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMaterials(rHIMLiningServiceV1ModelsCreateMaterialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.postMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /materials/search - POST
         * @param {RHIMLiningServiceDataMaterialSearchRequest} [rHIMLiningServiceDataMaterialSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMaterialsSearch(rHIMLiningServiceDataMaterialSearchRequest?: RHIMLiningServiceDataMaterialSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMaterialsSearch(rHIMLiningServiceDataMaterialSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.postMaterialsSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /materials/{materialId} - PUT
         * @param {string} materialId 
         * @param {RHIMLiningServiceV1ModelsUpdateMaterialDto} [rHIMLiningServiceV1ModelsUpdateMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMaterialsMaterialid(materialId: string, rHIMLiningServiceV1ModelsUpdateMaterialDto?: RHIMLiningServiceV1ModelsUpdateMaterialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMaterialsMaterialid(materialId, rHIMLiningServiceV1ModelsUpdateMaterialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialsApi.putMaterialsMaterialid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaterialsApi - factory interface
 */
export const MaterialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaterialsApiFp(configuration)
    return {
        /**
         * 
         * @summary /materials/{materialId} - DELETE
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaterialsMaterialid(materialId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMaterialsMaterialid(materialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /materials - GET
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterials(cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto> {
            return localVarFp.getMaterials(cursor, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /materials/{materialId} - GET
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialsMaterialid(materialId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsMaterialDto> {
            return localVarFp.getMaterialsMaterialid(materialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /materials/search?Filter={Filter}&OrderBy={OrderBy} - GET
         * @param {Array<RHIMContractsPropertyFilter>} filter 
         * @param {Array<RHIMContractsPropertyOrder>} orderBy 
         * @param {string} [term] 
         * @param {string} [source] 
         * @param {string} [industry] 
         * @param {string} [materialCharacteristics] 
         * @param {string} [supplierId] 
         * @param {string} [materialMainProductGroupId] 
         * @param {number} [pageSize] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialsSearchFilterFilterOrderbyOrderby(filter: Array<RHIMContractsPropertyFilter>, orderBy: Array<RHIMContractsPropertyOrder>, term?: string, source?: string, industry?: string, materialCharacteristics?: string, supplierId?: string, materialMainProductGroupId?: string, pageSize?: number, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto> {
            return localVarFp.getMaterialsSearchFilterFilterOrderbyOrderby(filter, orderBy, term, source, industry, materialCharacteristics, supplierId, materialMainProductGroupId, pageSize, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /materials - POST
         * @param {RHIMLiningServiceV1ModelsCreateMaterialDto} [rHIMLiningServiceV1ModelsCreateMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMaterials(rHIMLiningServiceV1ModelsCreateMaterialDto?: RHIMLiningServiceV1ModelsCreateMaterialDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsMaterialDto> {
            return localVarFp.postMaterials(rHIMLiningServiceV1ModelsCreateMaterialDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /materials/search - POST
         * @param {RHIMLiningServiceDataMaterialSearchRequest} [rHIMLiningServiceDataMaterialSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMaterialsSearch(rHIMLiningServiceDataMaterialSearchRequest?: RHIMLiningServiceDataMaterialSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<RHIMContractsPageResultOfRHIMLiningServiceV1ModelsMaterialDto> {
            return localVarFp.postMaterialsSearch(rHIMLiningServiceDataMaterialSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /materials/{materialId} - PUT
         * @param {string} materialId 
         * @param {RHIMLiningServiceV1ModelsUpdateMaterialDto} [rHIMLiningServiceV1ModelsUpdateMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMaterialsMaterialid(materialId: string, rHIMLiningServiceV1ModelsUpdateMaterialDto?: RHIMLiningServiceV1ModelsUpdateMaterialDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsMaterialDto> {
            return localVarFp.putMaterialsMaterialid(materialId, rHIMLiningServiceV1ModelsUpdateMaterialDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaterialsApi - object-oriented interface
 */
export class MaterialsApi extends BaseAPI {
    /**
     * 
     * @summary /materials/{materialId} - DELETE
     * @param {string} materialId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMaterialsMaterialid(materialId: string, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).deleteMaterialsMaterialid(materialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /materials - GET
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMaterials(cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).getMaterials(cursor, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /materials/{materialId} - GET
     * @param {string} materialId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMaterialsMaterialid(materialId: string, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).getMaterialsMaterialid(materialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /materials/search?Filter={Filter}&OrderBy={OrderBy} - GET
     * @param {Array<RHIMContractsPropertyFilter>} filter 
     * @param {Array<RHIMContractsPropertyOrder>} orderBy 
     * @param {string} [term] 
     * @param {string} [source] 
     * @param {string} [industry] 
     * @param {string} [materialCharacteristics] 
     * @param {string} [supplierId] 
     * @param {string} [materialMainProductGroupId] 
     * @param {number} [pageSize] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMaterialsSearchFilterFilterOrderbyOrderby(filter: Array<RHIMContractsPropertyFilter>, orderBy: Array<RHIMContractsPropertyOrder>, term?: string, source?: string, industry?: string, materialCharacteristics?: string, supplierId?: string, materialMainProductGroupId?: string, pageSize?: number, cursor?: string, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).getMaterialsSearchFilterFilterOrderbyOrderby(filter, orderBy, term, source, industry, materialCharacteristics, supplierId, materialMainProductGroupId, pageSize, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /materials - POST
     * @param {RHIMLiningServiceV1ModelsCreateMaterialDto} [rHIMLiningServiceV1ModelsCreateMaterialDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMaterials(rHIMLiningServiceV1ModelsCreateMaterialDto?: RHIMLiningServiceV1ModelsCreateMaterialDto, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).postMaterials(rHIMLiningServiceV1ModelsCreateMaterialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /materials/search - POST
     * @param {RHIMLiningServiceDataMaterialSearchRequest} [rHIMLiningServiceDataMaterialSearchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMaterialsSearch(rHIMLiningServiceDataMaterialSearchRequest?: RHIMLiningServiceDataMaterialSearchRequest, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).postMaterialsSearch(rHIMLiningServiceDataMaterialSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /materials/{materialId} - PUT
     * @param {string} materialId 
     * @param {RHIMLiningServiceV1ModelsUpdateMaterialDto} [rHIMLiningServiceV1ModelsUpdateMaterialDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putMaterialsMaterialid(materialId: string, rHIMLiningServiceV1ModelsUpdateMaterialDto?: RHIMLiningServiceV1ModelsUpdateMaterialDto, options?: RawAxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).putMaterialsMaterialid(materialId, rHIMLiningServiceV1ModelsUpdateMaterialDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuppliersApi - axios parameter creator
 */
export const SuppliersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /suppliers/{supplierId} - DELETE
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuppliersSupplierid: async (supplierId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('deleteSuppliersSupplierid', 'supplierId', supplierId)
            const localVarPath = `/suppliers/{supplierId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /suppliers - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /suppliers/{supplierId} - GET
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliersSupplierid: async (supplierId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSuppliersSupplierid', 'supplierId', supplierId)
            const localVarPath = `/suppliers/{supplierId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /suppliers - POST
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSuppliers: async (rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /suppliers/{supplierId} - PUT
         * @param {string} supplierId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSuppliersSupplierid: async (supplierId: string, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('putSuppliersSupplierid', 'supplierId', supplierId)
            const localVarPath = `/suppliers/{supplierId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuppliersApi - functional programming interface
 */
export const SuppliersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuppliersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /suppliers/{supplierId} - DELETE
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSuppliersSupplierid(supplierId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSuppliersSupplierid(supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.deleteSuppliersSupplierid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /suppliers - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuppliers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMLiningServiceV1ModelsSupplierDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuppliers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.getSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /suppliers/{supplierId} - GET
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuppliersSupplierid(supplierId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsSupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuppliersSupplierid(supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.getSuppliersSupplierid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /suppliers - POST
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSuppliers(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsSupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSuppliers(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.postSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /suppliers/{supplierId} - PUT
         * @param {string} supplierId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSuppliersSupplierid(supplierId: string, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMLiningServiceV1ModelsSupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSuppliersSupplierid(supplierId, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.putSuppliersSupplierid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuppliersApi - factory interface
 */
export const SuppliersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuppliersApiFp(configuration)
    return {
        /**
         * 
         * @summary /suppliers/{supplierId} - DELETE
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuppliersSupplierid(supplierId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSuppliersSupplierid(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /suppliers - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliers(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMLiningServiceV1ModelsSupplierDto>> {
            return localVarFp.getSuppliers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /suppliers/{supplierId} - GET
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuppliersSupplierid(supplierId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsSupplierDto> {
            return localVarFp.getSuppliersSupplierid(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /suppliers - POST
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSuppliers(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsSupplierDto> {
            return localVarFp.postSuppliers(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /suppliers/{supplierId} - PUT
         * @param {string} supplierId 
         * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSuppliersSupplierid(supplierId: string, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMLiningServiceV1ModelsSupplierDto> {
            return localVarFp.putSuppliersSupplierid(supplierId, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuppliersApi - object-oriented interface
 */
export class SuppliersApi extends BaseAPI {
    /**
     * 
     * @summary /suppliers/{supplierId} - DELETE
     * @param {string} supplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSuppliersSupplierid(supplierId: string, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).deleteSuppliersSupplierid(supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /suppliers - GET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuppliers(options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).getSuppliers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /suppliers/{supplierId} - GET
     * @param {string} supplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuppliersSupplierid(supplierId: string, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).getSuppliersSupplierid(supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /suppliers - POST
     * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postSuppliers(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).postSuppliers(rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /suppliers/{supplierId} - PUT
     * @param {string} supplierId 
     * @param {RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto} [rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putSuppliersSupplierid(supplierId: string, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto?: RHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).putSuppliersSupplierid(supplierId, rHIMLiningServiceV1ModelsCreateOrUpdateSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }
}



